import React from "react";

/** Pivony mark for orbit center — inline SVG, no image background */
const PivonyOrbitIcon = ({ size = 64, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    className={className}
    aria-hidden="true"
  >
    <circle cx="16" cy="16" r="16" fill="#33125B" />
    <circle cx="16" cy="16" r="13" fill="#511C99" />
    <circle cx="16" cy="16" r="9.5" fill="#BD2B95" />
    <circle cx="16" cy="16" r="5.5" fill="#FFFFFF" />
    <circle cx="16" cy="13.2" r="1.4" fill="#BD2B95" />
    <circle cx="16" cy="16" r="1.4" fill="#BD2B95" />
    <circle cx="16" cy="18.8" r="1.4" fill="#BD2B95" />
  </svg>
);

export default PivonyOrbitIcon;
